// eslint-disable-next-line
module.exports = {
  LOGIN_SUCCES: 'LOGIN_SUCCES',
  LOGIN_FAIL: 'LOGIN_FAIL',
  LOGOUT: 'LOGOUT',
  EDIT_USER: 'EDIT_USER',
};
